import styled from "@emotion/styled";

export const AccentBar = styled.div`
  background-color: #dcdcdc;
  height: 100%;
  width: 1.5px;
  border-radius: 0.25rem 0.25rem 0 0;
`;

export const InnerPlayheadWrapper = styled.div`
  position: sticky;
  top: -5px;
`;

export const PlayheadWrapper = styled.div`
  pointer-events: none;
  position: absolute;
  top: 0;
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
